module.exports = __webpack_public_path__ + "static/media/17.1fad2b06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/17.jpg
// module id = 278
// module chunks = 0